import React from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FloatingBtn from './components/FloatingBtn';
import DoctorPatients from './pages/DoctorPatients';
import Home from './pages/Home';
import Map from './pages/Map';
import Pay from "./pages/Pay";
import Reservation from './pages/Reservation';
import ServiceSingle from './pages/ServiceSingle';
import PR from './pages/PR';
import SurveyLanding from './pages/SurveyLanding';
import SurveyForm from './pages/SurveyForm';

function AppContent() {
  const location = useLocation();
  const isSurveyPage = location.pathname.startsWith('/survey');

  return (
    <>
      <Routes>
        <Route path={"*"} element={<Navigate to={'/'} />} />
        <Route path={"/"} element={<Home />} />
        <Route path={"/reservation"} element={<Reservation />} />
        <Route path={"/doctor-patients"} element={<DoctorPatients />} />
        <Route path={"/map"} element={<Map />} />
        <Route path={"/service/:serviceId"} element={<ServiceSingle />} />
        <Route path={"/pay"} element={<Pay />} />
        <Route path={"/pr"} element={<PR />} />
        <Route path={"/survey"} element={<SurveyLanding />} />
        <Route path={"/survey/admission"} element={<SurveyForm kind="admission" />} />
        <Route path={"/survey/center"} element={<SurveyForm kind="center" />} />
        <Route path={"/survey/report"} element={<SurveyForm kind="report" />} />
        <Route path={"/survey/result-delivery"} element={<SurveyForm kind="result_delivery" />} />
        <Route path={"/survey/technologist"} element={<SurveyForm kind="technologist" />} />
      </Routes>
      {!isSurveyPage && <FloatingBtn />}
      <ToastContainer autoClose={3000} rtl />
    </>
  );
}

function App() {
  return <BrowserRouter><AppContent /></BrowserRouter>;
}

export default App;
